import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bad90cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-20" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "提交工单", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("创建")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("提交并继续创建")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("清空")


const __default__ = {
    name:'NewTicket'
}
import {ref, reactive, computed, onBeforeMount, nextTick, onMounted,shallowRef, onBeforeUnmount} from 'vue'
import {ElMessage, ElMessageBox, genFileId} from 'element-plus'
import store from "@/store/index";
import { exportHandle } from '@/utils/index'
import "@wangeditor/editor/dist/css/style.css";
import Api from '@/http/modules/index'
import { useRoute,useRouter} from 'vue-router'
import TextEditor from "./TextEditor.vue"

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
    // 项目列表
    'GET/tickets/projects':ticketsProjectsApi,
    // 语言列表
    'GET/languages':languagesApi,
    // 行业列表
    'GET/industries':ticketsIndustriesApi,
    // 新增工单
    'POST/tickets':addTicketsApi

} = Api
const router=useRouter()
const ticketsProjects=ref([])
const currentProject=ref<any>({})

const ticketForm=ref<any>({})
const ticketFormRef=ref()
const languageLists=ref([])
const ticketsIndustries=ref([])
// 选择工单归属
const ticketsHandel=(projectId:any)=>{
    let res=ticketsProjects.value.find((el:any)=>el.projectId==projectId)
    currentProject.value=res||{}
    ticketForm.value={projectId}
}
// 判断编辑器输入内容是否为空
const getText = (str:any) => {
    return str
    .replace(/<[^<p>]+>/g, "") // 将所有<p>标签 replace ''
    .replace(/<[</p>$]+>/g, "") // 将所有</p>标签 replace ''
    .replace(/&nbsp;/gi, "") // 将所有 空格 replace ''
    .replace(/<[^<br/>]+>/g, ""); // 将所有 换行符 replace ''
}
const isNull = (str:any) => {
    if (str == "") return true;
    var regu = "^[ ]+$";
    var re = new RegExp(regu);
    return re.test(str);
}
// 校验编辑器内容
const checkDes=(rule:any,value:any,cb:any)=>{
    let text=getText(value)
    if(isNull(text)){
       cb("请输入详细描述") 
       return
    }
    cb()
}
// 创建工单
const creatLoading=ref(false)
const creatTicket=(formEl:any,isContinue:boolean)=>{
    if (!formEl) return
    formEl.validate((valid:any) => {
    if (valid) {
        let params={
          ...ticketForm.value
        }
        creatLoading.value=true
        addTicketsApi(params).then((res:any)=>{
            ElMessage.success("创建成功")
            creatLoading.value=false
            if(isContinue){
                resetSetting()
                return
            }
            router.push({name:'TicketLists',query:{tag:'Submit'}})
        }).catch(()=>{
            creatLoading.value=false
        })
    }
  })
}
const resetSetting=()=>{
    ticketFormRef.value?ticketFormRef.value.resetFields():""
    currentProject.value={}
}
onMounted(()=>{
    ticketsProjectsApi({disable:1}).then((res:any)=>{
        ticketsProjects.value=res
    })
    languagesApi().then((res:any)=>{
        languageLists.value=res
    })
    ticketsIndustriesApi().then((res:any)=>{
            ticketsIndustries.value=res
        })
    })

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_el_divider),
    _createVNode(_component_el_form, {
      ref_key: "ticketFormRef",
      ref: ticketFormRef,
      style: {"max-width":"1000px","padding":"10px"},
      model: ticketForm.value,
      "label-width": "auto",
      inline: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "工单提给",
          prop: "projectId",
          rules: [{ required: true, message: '请选择工单项目' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              filterable: "",
              modelValue: ticketForm.value.projectId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ticketForm.value.projectId) = $event)),
              onChange: ticketsHandel
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticketsProjects.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.projectId,
                    label: item.name,
                    value: item.projectId
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "服务类型",
          prop: "typeId",
          rules: [{ required: true, message: '请选择服务类型' }]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              filterable: "",
              modelValue: ticketForm.value.typeId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ticketForm.value.typeId) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentProject.value.typeList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.typeId,
                    label: item.name,
                    value: item.typeId
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (currentProject.value.options&&currentProject.value.options.industry)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "所属行业",
              prop: "industryId",
              rules: [{ required: true, message: '请选择所属行业' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  modelValue: ticketForm.value.industryId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ticketForm.value.industryId) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticketsIndustries.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.industryId,
                        label: item.name,
                        value: item.industryId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (currentProject.value.options&&currentProject.value.options.language)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "源语言",
              prop: "srcLang",
              rules: [{ required: true, message: '请选择源语言' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: ticketForm.value.srcLang,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ticketForm.value.srcLang) = $event)),
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageLists.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        disabled: item.code==ticketForm.value.trgLang,
                        key: item.code,
                        label: item.name,
                        value: item.code
                      }, null, 8, ["disabled", "label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (currentProject.value.options&&currentProject.value.options.language)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: "目标语言",
              prop: "trgLang",
              rules: [{ required: false, message: '请选择目标语言' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: ticketForm.value.trgLang,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ticketForm.value.trgLang) = $event)),
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languageLists.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        disabled: item.code==ticketForm.value.srcLang,
                        key: item.code,
                        label: item.name,
                        value: item.code
                      }, null, 8, ["disabled", "label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: "",
          prop: "description",
          rules: [{ required: true, message: '请输入详细描述' }, { validator: checkDes, trigger: 'blur' }]
        }, {
          default: _withCtx(() => [
            _createVNode(TextEditor, {
              onSetData: _cache[5] || (_cache[5] = val=>ticketForm.value.description=val),
              description: ticketForm.value.description
            }, null, 8, ["description"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_el_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                loading: creatLoading.value,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (creatTicket(ticketFormRef.value,false)))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                loading: creatLoading.value,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (creatTicket(ticketFormRef.value,true)))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                disabled: creatLoading.value,
                onClick: resetSetting
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ], 64))
}
}

})